export interface GoalContextLink {
  readonly memberId: string;
  readonly reason: string;
  readonly source: "human" | "cleo";
  readonly author: string;
}
export interface GoalRelationships {
  readonly parentIds: ReadonlyArray<string>;
  readonly dependsOn: ReadonlyArray<string>;
  readonly contextLinks: ReadonlyArray<GoalContextLink>;
  readonly relationSeq: number;
}
export function parseGoalRelationships(
  row: Record<string, unknown>,
): GoalRelationships | undefined {
  if (
    row["parentIds"] === undefined &&
    row["dependsOn"] === undefined &&
    row["contextLinks"] === undefined &&
    row["relationSeq"] === undefined
  )
    return {
      parentIds: typeof row["parent"] === "string" ? [row["parent"]] : [],
      dependsOn: [],
      contextLinks: [],
      relationSeq: 0,
    };
  const parents = row["parentIds"],
    dependencies = row["dependsOn"],
    links = row["contextLinks"],
    seq = row["relationSeq"];
  const ids = (value: unknown): value is string[] =>
    Array.isArray(value) &&
    value.every((id) => typeof id === "string" && id.length > 0) &&
    new Set(value).size === value.length;
  if (
    !ids(parents) ||
    !ids(dependencies) ||
    !Array.isArray(links) ||
    typeof seq !== "number" ||
    !Number.isSafeInteger(seq) ||
    seq < 0
  )
    return undefined;
  const contextLinks: GoalContextLink[] = [];
  for (const item of links) {
    if (!item || typeof item !== "object") return undefined;
    const link = item as Record<string, unknown>;
    if (
      typeof link["memberId"] !== "string" ||
      typeof link["reason"] !== "string" ||
      (link["source"] !== "human" && link["source"] !== "cleo") ||
      typeof link["author"] !== "string"
    )
      return undefined;
    contextLinks.push({
      memberId: link["memberId"],
      reason: link["reason"],
      source: link["source"],
      author: link["author"],
    });
  }
  return { parentIds: parents, dependsOn: dependencies, contextLinks, relationSeq: seq };
}
